import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import Button from '../Button';
import s from './ButtonB5.scss';
/**
 * B5 button in DS
 */
var ButtonB5 = /** @class */ (function (_super) {
    tslib_1.__extends(ButtonB5, _super);
    function ButtonB5() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonB5.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, rest = tslib_1.__rest(_a, ["className", "children"]);
        return (React.createElement(Button, tslib_1.__assign({}, rest, { className: classnames(s['button'], className), fullWidth: false }),
            this.renderIcon(),
            children));
    };
    ButtonB5.prototype.renderIcon = function () {
        var Component = this.props.icon;
        var _a = this.props.iconProps, className = _a.className, rest = tslib_1.__rest(_a, ["className"]);
        return React.createElement(Component, tslib_1.__assign({ className: classnames(s['icon'], className) }, rest));
    };
    return ButtonB5;
}(React.Component));
export default ButtonB5;
//# sourceMappingURL=ButtonB5.js.map